import {useNavigate, useOutlet} from 'react-router-dom';
import useShipmentQueryStore from "../../data/ShipmentQuery.store";
import {useShipments} from "../../api/Shipment/Shipment.hooks";
import LoaderDefault from "../../components/common/Loader.default/Loader.default";
import ShipmentTable from "../../components/project/Shipment.table/Shipment.table";
import {Button, Divider, Group, Stack, Text, Title} from "@mantine/core";
import {ArrowLeft} from "tabler-icons-react";

function ShipmentQueryResults() {
    const {shipmentQuery} = useShipmentQueryStore();
    const outlet = useOutlet();
    const {isLoading: shipmentsLoading, data: shipments} = useShipments(shipmentQuery);
    const navigate = useNavigate();

    if (outlet) {
        return outlet;
    }

    if (shipmentsLoading) {
        return <LoaderDefault text="Loading shipments data..."/>
    }

    function onReferenceNumberClick(referenceNumber: string) {
        navigate(`/shipment-tracking/shipments/${referenceNumber}`)
    }

    return (
        <Stack>
            <Group position="apart">
                <Title order={3} style={{color: "#C1C2C5"}}>Shipment Query Results</Title>
                <Button leftIcon={<ArrowLeft/>} color="blue" onClick={() => navigate("/shipment-tracking")}>
                    Back to Shipment Query
                </Button>
            </Group>
            <Divider/>
            {shipments ?
            <ShipmentTable shipments={shipments} onReferenceNumberClick={onReferenceNumberClick}/>
            :
            <Text color="white">No shipment data found.</Text>}
        </Stack>
    )
}

export default ShipmentQueryResults;